const DEFAULT_ONBOARDING_CALL_URL =
  'mailto:support@frame-book.com?subject=Onboarding%20Call%20Request&body=Hi%20Frame-Book%20team%2C%20I%20would%20like%20to%20book%20a%2030-minute%20onboarding%20call.';

export const ONBOARDING_CALL_URL =
  process.env.REACT_APP_ONBOARDING_CALL_URL || DEFAULT_ONBOARDING_CALL_URL;
